var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"OperateLhc-integration"},[_c('group',{attrs:{"client":_vm.client,"list":_vm.Table[1],"length":1,"show-total":"end","integration":1,"disabled":""}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block c-text-6 o-mt-s"},[_c('p',{staticClass:"c-text-c o-p"},[_vm._v("注意：特整合包含，特单、特双、特大、特小、合单、合双、合大、合小、尾大、尾小、合尾大、合尾小、红波、蓝波、绿波、大单、大双、小单、小双、家禽、野兽、特半波、特肖、合肖")])])
}]

export { render, staticRenderFns }